export default [
  {
    name: "Aberra Bulk Messaging",
    image: require("../assets/img/products/aberra.png"),
    page: "aberra-messaging",
    summary: "Bulk Messaging service for emails and SMSes",
  },
  {
    name: "Hobbot Multichannel Chatbot",
    image: require("../assets/img/products/hobbot.png"),
    page: "hobbot",
    summary:
      "Social media chat bot that can be used to automate and increase your business reach through social media channels",
  },
  {
    name: "LendPro Loans Management System",
    image: require("../assets/img/products/lendpro.png"),
    page: "lendpro",
    summary:
      "Modern Loan Management System, with online loan applications and tracking",
  },
  {
    name: "Provest Investment Systems",
    image: require("../assets/img/products/provest.png"),
    page: "provest",
    summary:
      "Investments System to manage Invoice discounting, livestock, remittances, medical equipments, equities, unit trusts, to mention but a few",
  },
];
